import { render } from "./InlineChannel.vue?vue&type=template&id=e318f974&ts=true"
import script from "./InlineChannel.vue?vue&type=script&lang=ts"
export * from "./InlineChannel.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__